module.exports = __webpack_public_path__ + "static/media/logo.fd00a3cd.svg";